export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["CHANGE_INPUT"] = "CHANGE_INPUT";
    ACTION["CHANGE_INPUT_PAN"] = "CHANGE_INPUT_PAN";
    ACTION["CHANGE_INPUT_PHONE"] = "CHANGE_INPUT_PHONE";
    ACTION["CHANGE_INPUT_EMAIL"] = "CHANGE_INPUT_EMAIL";
    ACTION["DISABLE_CONTINUE"] = "DISABLE_CONTINUE";
    ACTION["ENABLE_CONTINUE"] = "ENABLE_CONTINUE";
    ACTION["TRIGGER_CTA"] = "TRIGGER_CTA";
    ACTION["ENTER_DOB"] = "ENTER_DOB";
})(ACTION || (ACTION = {}));
